/*
 * IMPORTS
 */
import { gql } from '@apollo/client'

/*
 * EXPORTS
 */
export default gql`
  query FallbackRouteReadQuery($routeId: ID!) {
    FallbackRouteRead(routeId: $routeId) {
      id
      displayName
      type
      CustomerAccount {
        id
        displayName
      }
    }
  }
`
